import { Conversation } from '@protos/apps/pc/conversation_pb'

export const normalizeConversations = (
  list: Conversation[]
): Record<Conversation['id'], Conversation> => {
  if (!list?.length) {
    return {}
  }

  return list.reduce((acc, item) => mergeConversation(item, acc), {})
}

export const mergeConversation = (
  item?: Conversation,
  record?: Record<Conversation['id'], Conversation>
): Record<Conversation['id'], Conversation> => {
  if (!item) {
    return record || {}
  }
  return {
    ...(record || {}),
    [item.id]: item,
  }
}

export const mergeConversations = (
  list: Conversation[],
  record?: Record<Conversation['id'], Conversation>
): Record<Conversation['id'], Conversation> => {
  return {
    ...(record || {}),
    ...normalizeConversations(list),
  }
}

export const listConversations = (
  record?: Record<Conversation['id'], Conversation>
) => Object.values(record || {}).sort((a, b) => b.id - a.id)
